import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalErrorHandler } from '../error.handler';

/**
 * Guard that prevents navigation to view if fatal exception has been thrown.
 * User is required to reload the site.
 */
@Injectable({
  providedIn: 'root'
})
export class ExceptionGuard  {
  constructor() {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let canActivate = !GlobalErrorHandler.isFatalError;
    return canActivate;
  }
  
}
